import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { ApolloQueryResult } from "@apollo/client";
import Queries from "../../../api/queries";
import { mobUser } from "../../../mobx/MobUser";
import { WifiInfos } from "../../../types/types";
import { MD3Theme, useTheme } from "react-native-paper";
import WifiCardSkeleton from "./WifiCardSkeleton";
import WifiCardInfos from "./WifiCardInfos";
import { observer } from "mobx-react";
import { SafeAreaView } from "react-native-safe-area-context";
import FooterDivider from "../../../components/FooterDivider";

const Wifi = observer(() => {
  const [wifiInfos, setWifiInfos] = useState<WifiInfos>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const queries = new Queries();
  const theme = useTheme();
  const styles = stylesGen(theme);


  useEffect(() => {
    let wifiSubscription;

    async function subscribeToWifiData() {
      try {
        const wifiObservable = await queries.getApartmentWifi(mobUser.OiqiaBookingId);
        wifiSubscription = wifiObservable.subscribe({
          next(response: ApolloQueryResult<{ NTA_getAppartmentCaract: WifiInfos }>) {
            setWifiInfos(response.data.NTA_getAppartmentCaract);
            setIsLoading(false);
          },
          error(err) {
            console.error("Error fetching wifi data:", err);
          }
        });
      } catch (error) {
        console.error("Error setting up subscription:", error);
      }
    }

    subscribeToWifiData();

    return () => {
      wifiSubscription?.unsubscribe();
    };
  }, []);

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <View style={styles.container}>
        <View style={styles.wifiCard}>
          {isLoading ?
            <WifiCardSkeleton />
            :
            <WifiCardInfos wifiInfos={wifiInfos} />
          }
        </View>
      </View>
      <FooterDivider />
    </SafeAreaView>
  );
});

const stylesGen = (theme: MD3Theme) => StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    paddingTop: 30
  },
  wifiCard: {
    borderColor: theme.colors.secondary,
    borderWidth: 3,
    width: "80%",
    borderRadius: 20,
    padding: 15,
    gap: 15,
    minHeight: 150
  },
  title: {
    fontSize: 20,
    fontFamily: "NotoSans-Bold"
  }
});

export default Wifi;